import type { Mouvement } from '@mairistem/comptabilite';
import { getErrorMessage } from '@mairistem/finances-utils';
import ActionResultType from '../../../../interfaces/pieces/ActionResultType';
import type { BaseLiquidationOptions } from '../../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import MouvementActionType from '../../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type TreeviewActionResult from '../../../../interfaces/pieces/TreeviewActionResult';
import { supprimerMouvement } from '../../../../services/piecesComptables/mouvements/mouvements';
import BaseLiquidationAction from '../../../pieces/BaseLiquidationAction';

class MouvementSupprimerAction extends BaseLiquidationAction<
	Mouvement,
	MouvementActionType
> {
	constructor(options: BaseLiquidationOptions = null) {
		super(options);
		this.label = 'Supprimer';
		this.type = MouvementActionType.DELETE;
	}

	execute = (mouvement: Mouvement): TreeviewActionResult<Mouvement> => ({
		type: ActionResultType.MODAL,
		result: Promise.resolve(mouvement),
		extraProps: {
			deleteModal: {
				visible: true,
				typeAction: MouvementActionType.DELETE,
			},
		},
	});

	executeAction = (mouvement: Mouvement): TreeviewActionResult<Mouvement> => ({
		result: new Promise((resolve, reject) => {
			supprimerMouvement(mouvement.identifiant as number)
				.then(() => {
					resolve(mouvement);
				})
				.catch((e) => {
					reject(
						Error(
							getErrorMessage(e, 'Erreur lors de la suppression du mouvement'),
						),
					);
				});
		}),
		type: ActionResultType.DELETE,
	});
}

export default MouvementSupprimerAction;
